<template>
    <b-container fluid class="mb-5">
        <b-media vertical-align="center">
            <b-row>
                <b-col sm="11" md="11" lg="11" xl="11">
                    <indicator-progress :target="target" :nameLink="true" />
                </b-col>
                <b-col sm="1" md="1" lg="1" xl="1" vertical-align="center" v-if="canHireGoal">
                    <c-switch
                        label
                        color="success"
                        variant="pill"
                        v-bind="{
                            dataOn: $t('form.switch.yes'),
                            dataOff: $t('form.switch.no'),
                        }"
                        v-model="selected"
                        :checked="true"
                        @change="$emit('changed', { id: goal.id, ev: $event })"
                        :ref="'target-switch-' + goal.id"
                    />
                </b-col>
            </b-row>
        </b-media>
    </b-container>
</template>
<script>
import { IndicatorProgress } from '@/views/target/components/view/indicator-header'
import { Switch as CSwitch } from '@coreui/vue'

import { stringsMixin } from '@/mixins'

export default {
    name: 'HireGoal',
    props: {
        goal: {
            type: Object,
            required: true,
        },
        canHireGoal: {
            type: Boolean,
            required: true,
        },
    },
    mixins: [stringsMixin],
    components: {
        IndicatorProgress,
        CSwitch,
    },
    data() {
        return {
            target: {
                owner: {
                    picture: null,
                    name: '',
                },
                ownerEvaluation: null,
                colors: {
                    ownerEvaluation: null,
                },
            },
            selected: false,
        }
    },
    created() {
        this.target = this.objectKeysToCamelCase(this.goal)
        this.target.progress = this.sanitizeTargetProgress(this.target.progress)
    },
    methods: {
        check(param) {
            this.selected = param
        },
        sanitizeTargetProgress() {
            return this.target.progress || 0
        },
    },
}
</script>
